<template>
    <header>
        <span class="btn" @click="router.back()"><van-icon name="arrow-left" size="20" /></span>
        <div class="input">
            <input type="text" v-model="searchValue" @change="changeTab(currentTab)" placeholder="请输入文章关键词搜索您需要的内容" />
            <img src="@/assets/imgs/icon16.png" />
        </div>
    </header>
    <div class="tabbar">
        <span :class="{ active: currentTab == 95 }" @click="changeTab(95)">行业资讯</span>
        <span :class="{ active: currentTab == 94 }" @click="changeTab(94)">公司公告</span>
    </div>

    <div class="news">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" :offset="100" @load="fetchList">
            <div class="news_item" v-for="item in newsList" @click="router.push('/news-detail?id='+item.id)">
                <img :src="item.iconImg + '?x-oss-process=image/resize,w_500'" class="banner_img">
                <div class="content">
                    <h5>{{ item.title }}</h5>
                    <p>{{ richTextToPlainText(item.contents) }}</p>
                    <div class="icons">
                        <span style="color: #9D9DA0;">{{ item.createTime.split('T')[0] }}</span>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { http } from '@/request/http'
import { useRoute, useRouter } from 'vue-router'
import { showNotify } from 'vant';
import { richTextToPlainText } from '@/utils/util'
import axios from 'axios';
const route = useRoute(), router = useRouter()
const currentTab = ref(95)
function changeTab(index) {
    finished.value = false
    currentTab.value = index
    newsList.value = []
    pageNo.value = 1
    fetchList()
}
const pageNo = ref(1)
const pageSize = 10
const finished = ref(false)
const loading = ref(false)
const newsList = ref([])
const searchValue = ref('')
function fetchList() {
    loading.value = true
    axios.post('https://www.dfshuke.com/pro-api/pc/content/getContentList', {
        "columnId": currentTab.value,
        "limit":pageSize,
        "page":pageNo.value,
        "sortType":1,
        "status":1,
        "title":searchValue.value,
        "websiteId":10000001
    }).then(res => {
        console.log(res);
        pageNo.value++
        loading.value = false
        newsList.value.push(...res.data.rows)
        finished.value = newsList.value.length >= res.data.total
    }).catch(err => {
        finished.value = true
        showNotify('服务器错误，请稍后重试')
    })
}

onMounted(() => {
    currentTab.value = route.query.type
    fetchList()
})
</script>

<style scoped lang="scss">
header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;

    .btn {
        width: 40rem;
        height: 40rem;
        display: block;
        text-align: center;
        line-height: 40rem;
    }

    .input {
        width: 90%;
        padding: 5rem 20rem;
        display: flex;
        align-items: center;
        background-color: #F5F5F5;
        input {
            width: 100%;
            font-size: 14rem;
            background: transparent;
        }

        input::placeholder {
            color: #D8D8D8;
        }

        img {
            width: 30rem;
            height: 30rem;
        }
    }
}

.tabbar {
    display: flex;
    border-bottom: 1px solid #F0F0F0;
    margin: 0 20rem;

    span {
        display: block;
        width: 50%;
        text-align: center;
        line-height: 40rem;
        height: 40rem;
        color: #9D9D9D;
    }

    .active {
        color: #000;
        border-bottom: 1px solid #000;
    }
}

.news {
    padding-top: 20rem;

    .news_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10rem 20rem;
        width: 100%;
        img {
            width: 122rem;
            height: 92rem;
            object-fit: cover;
            flex-shrink: 0;
            margin-right: 20rem;
        }

        .content {
            width: calc(100% - 122rem - 20rem);
            h5 {
                font-size: 14rem;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 50%;
            }
            p{
                font-size: 12rem;
                color: #717171;
                margin-top: 10rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            .icons {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10rem;
                font-size: 12rem;
                width: 100%;
                span{
                    color: #717171; display: flex; align-items: center;
                }
            }
        }
    }

}
</style>